export default function (uku) {
    this.isCheckboxSelected = true;
    this.sex = "female";
};


//////////////////
// WEBPACK FOOTER
// ./resources/js/example11.js
// module id = 13
// module chunks = 0